export default __webpack_public_path__ + "static/media/273.739b20d3.png";